export default "<h1>Pagina non trovata!</h1>\n";